/*
    because fetch() does not return errors in a failure kind of way,
    this helper takes the response and if there's an error it throws
    an exception.  Else it returns a promise resolving to the
    json of the response body.
 */
const WORKSPACE_REQUIRED_ERROR = 'error_workspace_required_to_use_username';

export const handleServiceCall = (response) => {
  if (response.status > 299) {
    return response.json().then(
      (errorJson) => {
        if (response.status === 400 && errorJson.error_code === 'LPS0109') {
          errorJson.message = WORKSPACE_REQUIRED_ERROR;
        }
        throw new Error(JSON.stringify(errorJson));
      },
      () => {
        // failed to even parse the json from the request
        throw new Error('error ' + response.status);
      }
    );
  }
  // Ego sends back an empty response body in the cors response to a post request,
  // which breaks response.json() - just return null in that case.
  return response.text().then(function(text) {
    if (text) {
      return JSON.parse(text);
    }
    return null;
  });
};



// WEBPACK FOOTER //
// ./src/modules/app/util/fetch-utils.js